import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'How to Ship Skis | Easy Door-to-Door Ski Shipping Service',
  description:
    'Learn how to ship skis and snowboards with ShipSkis. Schedule your shipment, ' +
    'pack your gear, and enjoy stress-free, door-to-door ski shipping anywhere in the world.',
  alternates: {
    canonical: 'https://www.shipskis.com/how-it-works',
  },
}

export default metadata
